module.exports = __webpack_public_path__ + "img/slide7.4d8b5f62.png";